<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  h3 {
    margin-bottom: utils.in_rem(16px);
  }

  .dropdowns {
    display: grid;
    gap: utils.in_rem(10px);
  }
</style>

<script>
  import SettingDropdown from "../../../components/shared/SettingDropdown.svelte";

  export let dropdownSettings = [];
</script>

{#if dropdownSettings?.length}
  <section>
    <h3>Displayed company information</h3>
    <div class="dropdowns">
      {#each dropdownSettings as setting (setting.key)}
        <SettingDropdown {setting} />
      {/each}
    </div>
  </section>
{/if}
